import { SearchParams } from "Pages/Search/index.types";
import { exportSet } from "Utils";
import { ApiResponse } from "types/OnDemand.types";

export type ResultItem = ApiResponse & { searchParams: SearchParams };

export const SEARCH_STORAGE_KEY = "2411bf39-6749-4f89-a712-09d6c1411897";
export const PROSPECTION_SEARCH_STORAGE_KEY =
  "d3f8a9c2-5b4e-4c7a-9e8f-2a6b7d1e3f4c";

export const getStorageValue = <T>(key: string): Set<T> => {
  try {
    const saved = localStorage.getItem(key);
    if (!saved) {
      return new Set<T>();
    }
    return new Set<T>(JSON.parse(saved, exportSet));
  } catch (e) {
    throw new Error("Problem when retrieving the local storage");
  }
};

export const addToStorageValue = <T>(key: string, value: T): void => {
  const previous = getStorageValue<T>(key);
  previous.add(value);
  localStorage.setItem(key, JSON.stringify(previous, exportSet));
};

export const setStorageValue = <T>(key: string, value: T): void => {
  localStorage.setItem(key, JSON.stringify(value, exportSet));
};

export const removeStorageValue = (key: string): void => {
  localStorage.removeItem(key);
};
